import { Flex, Link, Text } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { useTranslation } from "@/hooks/useTranslation"
import { ExternalLinkOutlined } from "@/icons"

import styles from "./OverviewStepsAdr.module.scss"

import type { PolicyViolationDescriptionProps } from "."

// The evidence line is one monospace string; inline emphasis tags from the
// translation would restyle part of it.
const toPlainText = (text = "") => text.replace(/<[^>]+>/g, "")

// Step description for a violated AI policy: the policy that caught it, linked,
// above the evidence of what was not allowed.
export const PolicyViolationDescription = (
  props: PolicyViolationDescriptionProps
) => {
  const { enforcement, text } = props
  const { policyId, policyName } = enforcement
  const { ROOT, AI } = NAMES_ROUTES.GOVERNANCE
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.adr.tabs.overview"
  })

  return (
    <Flex vertical gap={4} className={styles.violation}>
      <Flex align="center" gap={5} className={styles.violationHeader}>
        <Text className={styles.violationLabel}>{t("aiPolicy")}:</Text>
        <Link
          type="link"
          className={styles.violationPolicy}
          to={`/${ROOT}/${AI}/${policyId}/view`}
        >
          <span>{policyName}</span>
          <ExternalLinkOutlined className={styles.violationIcon} />
        </Link>
      </Flex>
      <div className={styles.violationEvidence}>{toPlainText(text)}</div>
    </Flex>
  )
}
